import { EmvConfigurationDtoToEntity } from "src/app/features/EmvKernelProfile/subFeatures/EmvConfiguration/services/mappers/EmvConfigurationDtoToEntity";
import type { EmvConfigurationDto } from "src/app/features/EmvKernelProfile/subFeatures/EmvConfiguration/types/EmvConfigurationDto";
import type { EmvConfigurationEntity } from "src/app/features/EmvKernelProfile/subFeatures/EmvConfiguration/types/EmvConfigurationEntity";
import type { ResourcePageDto } from "../../../../../../../core/types/be/ResourcePageDto";
import type { ResourcePageEntity } from "../../../../../../../core/types/fe/entities/ResourcePageEntity";

export const EmvConfigurationTableDtoMapper = (
    input: Readonly<ResourcePageDto<EmvConfigurationDto>>,
): ResourcePageEntity<EmvConfigurationEntity> => {
    return {
        list: input.list ? input.list.map(EmvConfigurationDtoToEntity) : [],
        currentPage: input.currentPage,
        totalPages: input.totalPages,
        totalNumberOfResults: input.totalNumberOfResults,
    };
};
